module.exports = __webpack_public_path__ + "images/choices/qrcode-zhiren-2a45024f94c85453aac4ae5a488259b9.jpg";